import { MainColor } from '../../../palette';

export const getPrimaryButtonThemeConfig = () => {
  return {
    contained: {
      states: {
        focusVisible: {
          backgroundColor: 'navy60' as MainColor,
        },
        active: {
          backgroundColor: 'navy60' as MainColor,
        },
        defaultState: {
          backgroundColor: 'navy80' as MainColor,
        },
        focus: {
          backgroundColor: 'navy80' as MainColor,
          outlineColor: 'navy60' as MainColor,
        },
        hover: {
          backgroundColor: 'navy70' as MainColor,
        },
      },
    },
    outlined: {
      states: {
        focusVisible: {
          backgroundColor: 'navy10' as MainColor,
        },
        active: {
          backgroundColor: 'navy10' as MainColor,
        },
        defaultState: {
          backgroundColor: 'navy80' as MainColor,
        },
        focus: {
          backgroundColor: 'white100' as MainColor,
          outlineColor: 'navy40' as MainColor,
        },
        hover: {
          backgroundColor: 'navy10' as MainColor,
        },
      },
    },
    text: {
      states: {
        hover: {
          color: 'navy70' as MainColor,
          backgroundColor: 'navy10' as MainColor,
        },
        active: {
          color: 'navy60' as MainColor,
          backgroundColor: 'navy10' as MainColor,
        },
        focusVisible: {
          color: 'navy60' as MainColor,
        },
        focus: {
          color: 'navy80' as MainColor,
          outlineColor: 'navy40' as MainColor,
        },
      },
    },
    menu: {
      states: {
        defaultState: {
          backgroundColor: 'navy80' as MainColor,
          color: 'navy80' as MainColor,
        },
        hover: {
          color: 'navy60' as MainColor,
          backgroundColor: 'navy10' as MainColor,
        },
        active: {
          color: 'navy60' as MainColor,
        },
        focusVisible: {
          color: 'navy70' as MainColor,
          backgroundColor: 'navy10' as MainColor,
        },
        focus: {
          color: 'navy80' as MainColor,
          outlineColor: 'navy40' as MainColor,
        },
        selected: {
          backgroundColor: 'forest10' as MainColor,
          color: 'forest50' as MainColor,
        },
      },
    },
    loading: {
      background: 'coolGrey20' as MainColor,
      border: 'coolGrey30' as MainColor,
      color: 'coolGrey50' as MainColor,
    },
  };
};
